<template>
  <el-date-picker
    style="width: 100%"
    v-model="dateRange"
    :type="type"
    :clearable="clearable"
    :picker-options="pickerOptions"
    :value-format="valueFormat"
    :format="valueFormat"
    size="small"
    start-placeholder="开始日期"
    end-placeholder="结束日期"
    @change="handleDateChange"></el-date-picker>
</template>

<script>
export default {
  props: {
    pickerOptions: {
      type: Object,
      default() {
        return {
          disabledDate(time) {
            return "";
          },
        };
      },
    },
    valueFormat: {
      type: String,
      default: "yyyy-MM-dd",
    },
    type: {
      type: String,
      default: "daterange",
    },
    startDate: {
      type: String,
      default: "",
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    endDate: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      dateRange: [this.startDate, this.endDate],
    };
  },
  watch: {
    startDate(newValue) {
      this.updateDateRange("start", newValue);
    },
    endDate(newValue) {
      this.updateDateRange("end", newValue);
    },
  },
  methods: {
    handleDateChange(value) {
      if (Array.isArray(value) && value.length === 2) {
        this.$emit("update:startDate", value[0]);
        this.$emit("update:endDate", value[1]);
      } else {
        // 如果需要处理取消选择的情况
        this.$emit("update:startDate", "");
        this.$emit("update:endDate", "");
      }
    },
    updateDateRange(type, newValue) {
      const index = type === "start" ? 0 : 1;
      this.dateRange = [...this.dateRange];
      this.dateRange[index] = newValue;
    },
  },
};
</script>

<style scoped lang="scss"></style>
